import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  // The app is currently served from the domain root.
  // To serve the app from a subpath, use BASE_URL like this:
  // history: createWebHistory(import.meta.env.BASE_URL)
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      alias: '/home',
      name: 'home',
      component: HomeView,
    },
    // Implement lazy loading of routes,
    // Use dynamic imports in the component property of the route.
    // For example:
    //   component: () => import('../views/SomeView.vue'),
    // This generates a separate chunk ([name].[hash].js) for this
    // route, which is lazy-loaded when the route is visited.
    {
      path: '/production/products',
      name: 'products',
      component: () => import('../views/PartDefinitionView.vue'),
    },
    {
      path: '/production/orders',
      name: 'orders',
      component: () => import('../views/OrderView.vue'),
    },
    {
      path: '/production/lots',
      name: 'lots',
      component: () => import('../views/LotView.vue'),
    },
    {
      path: '/production/locations',
      name: 'locations',
      component: () => import('../views/LocationView.vue'),
    },
    {
      path: '/production/variants',
      name: 'variants',
      component: () => import('../views/VariantView.vue'),
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('../views/ProfileView.vue'),
    },
    // Add dev only features on dev mode only
    ...(import.meta.env.DEV
      ? [
          {
            path: '/demo/table',
            name: 'demo-table',
            component: () => import('../views/DemoTableView.vue'),
          },
        ]
      : []),
  ],
})

export default router
